import {observer} from "mobx-react";
import React from "react";
import {Swiper, SwiperSlide} from "swiper/react/swiper-react";
import {Pagination, Navigation} from "swiper";
import {OrbitComponent} from "../../../../base-components/orbit-component/orbit-component";
import {VouchersSwiperBox} from "../../../boxes/vouchers-swiper/vouchers-swiper.box";
import {VoucherSwiperArrowContainerBox} from "../../../boxes/vouchers-swiper/arrow/voucher-swiper-arrow-container.box";
import {IFreePlayVoucherViewModel} from "../../../../../services/free-play/vouchers/free-play-voucher-view-model.interface";
import {VoucherCardComponent} from "../voucher-card.component";
import {CyClass} from "../../../../../../common/cy-classes";

interface VouchersSwiperComponentProps {
    onCurrentVoucherIndexChanged: (voucherIndex: number) => void;
}

@observer
export class VouchersSwiperComponent extends OrbitComponent<VouchersSwiperComponentProps> {
    prevElement = React.createRef<HTMLDivElement>();
    nextElement = React.createRef<HTMLDivElement>();

    private get _vouchers(): IFreePlayVoucherViewModel[] {
        return this.services.freePlay.userVouchers;
    }

    render() {
        return (<VouchersSwiperBox>
            <VoucherSwiperArrowContainerBox isPrev={true} ref={this.prevElement} className={CyClass('cy-vouchers-previous-button')} />
            <VoucherSwiperArrowContainerBox ref={this.nextElement} className={CyClass('cy-vouchers-next-button')} />
            <Swiper
                dir={this.services.language.isRTLLanguage ? "rtl" : "ltr"}
                style={{width: "100%"}}
                slidesPerView={this.services.mediaQuery.sAndBelow ? 1.6 : 1}
                centeredSlides={true}
                pagination={{
                    clickable: true
                }}
                navigation={{
                    nextEl: this.nextElement.current,
                    prevEl: this.prevElement.current
                }}
                modules={[Pagination, Navigation]}
                className="freeplayVouchersSwiper"
                // solution taken from: https://stackoverflow.com/questions/64099383/swiper-react-how-to-create-custom-navigation-pagination-components-using-react
                onBeforeInit={(swiper) => {
                    if (typeof swiper.params.navigation !== "boolean") {
                        swiper.params.navigation.prevEl = this.prevElement.current;
                        swiper.params.navigation.nextEl = this.nextElement.current;
                    }
                }}
                onActiveIndexChange={(swiper) => {
                    this.props.onCurrentVoucherIndexChanged(swiper.activeIndex);
                }}
            >
                {this._vouchers.map((v) => {
                    return <SwiperSlide key={v.id}>
                        {({ isActive }) => {
                            return <VoucherCardComponent key={v.id} voucher={v}/>
                        }}
                    </SwiperSlide>
                })}
            </Swiper>
        </VouchersSwiperBox>)
    }
}